























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ContattoAziendaInfo } from "../../_models/contattoAzienda";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class ContattoAziendaCreate extends Vue {
  @Prop() idAzienda!: number;
  @Prop() idIstituto!: number;
  private nominativo: string;
  private mansione: string;
  private telefonoUno: string;
  private telefonoDue: string;
  private fax: string;
  private email: string;
  private emailPec: string;
  private note: string;

  private nominativoRules: [boolean | string];
  private mansioneRules: [boolean | string];
  private telefonoUnoRules: [boolean | string];
  private telefonoDueRules: [boolean | string];
  private faxRules: [boolean | string];
  private emailRules: [boolean | string];
  private emailPecRules: [boolean | string];
  private noteRules: [boolean | string];

  constructor() {
    super();
    this.nominativo = "";
    this.mansione = "";
    this.telefonoUno = "";
    this.telefonoDue = "";
    this.fax = "";
    this.email = "";
    this.emailPec = "";
    this.note = "";

    this.nominativoRules = [true];
    this.mansioneRules = [true];
    this.telefonoUnoRules = [true];
    this.telefonoDueRules = [true];
    this.faxRules = [true];
    this.emailRules = [true];
    this.emailPecRules = [true];
    this.noteRules = [true];
  }

  validazioneNominativo() {
    var valid: boolean = false;
    if (this.nominativo !== "") {
      valid = /^[a-zA-Z0-9ìèéùòà,.'\x20]{2,100}$/.test(this.nominativo);
    }
    if (valid) {
      this.nominativoRules = [true];
    } else if (this.nominativo === "") {
      this.nominativoRules = ["Nominativo necessario"];
    } else {
      this.nominativoRules = [
        "Nominativo deve essere compreso tra 2 e 100 caratteri"
      ];
    }
  }

  validazioneMansione() {
    var valid: boolean = false;
    if (this.mansione === "") {
      this.mansioneRules = [true];
    } else {
      valid = /^[a-zA-Z0-9ìèéùòà,.'\x20]{2,100}$/.test(this.mansione);
      if (valid) {
        this.mansioneRules = [true];
      } else {
        this.mansioneRules = [
          "Mansione non può avere più di 100 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }

  validazioneTel() {
    var valid1: boolean = false;
    var valid2: boolean = false;
    var valid3: boolean = false;
    if (this.telefonoUno === "" || this.telefonoUno === null) {
      this.telefonoUnoRules = [true];
    } else {
      valid1 = /[0-9]{8,15}$/.test(this.telefonoUno);
      if (valid1) {
        this.telefonoUnoRules = [true];
      } else {
        this.telefonoUnoRules = [
          "Il numero di telefono non ha un formato corretto"
        ];
      }
    }
    if (this.telefonoDue === "" || this.telefonoDue === null) {
      this.telefonoDueRules = [true];
    } else {
      valid2 = /[0-9]{8,15}$/.test(this.telefonoDue);

      if (valid2) {
        this.telefonoDueRules = [true];
      } else {
        this.telefonoDueRules = [
          "Il numero di telefono non ha un formato corretto"
        ];
      }
    }
    if (this.fax === "" || this.fax === null) {
      this.faxRules = [true];
    } else {
      valid3 = /[0-9]{8,15}$/.test(this.fax);
      if (valid3) {
        this.faxRules = [true];
      } else {
        this.faxRules = ["Il numero di fax non ha un formato corretto"];
      }
    }
  }

  validazioneEmail() {
    var valid: boolean = false;
    if (this.email === "") {
      this.emailRules = [true];
    } else {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(this.email);
      if (valid) {
        this.emailRules = [true];
      } else {
        this.emailRules = ["Formato Email non corretto"];
      }
    }
  }

  validazioneEmailPec() {
    var valid: boolean = false;
    if (this.emailPec === "") {
      this.emailPecRules = [true];
    } else {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailPec
      );
      if (valid) {
        this.emailPecRules = [true];
      } else {
        this.emailPecRules = ["Formato Email Pec non corretto"];
      }
    }
  }

  validazioneNote() {
    var valid: boolean = false;
    if (this.note === "") {
      this.noteRules = [true];
    } else {
      valid = /^[a-zA-Z0-9ìèéùòà,.'\x20]{2,250}$/.test(this.note);
      if (valid) {
        this.noteRules = [true];
      } else {
        this.noteRules = [
          "Note non può avere più di 250 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }

  close() {
    this.nominativo = "";
    this.mansione = "";
    this.telefonoUno = "";
    this.telefonoDue = "";
    this.fax = "";
    this.email = "";
    this.emailPec = "";
    this.note = "";

    this.nominativoRules = [true];
    this.mansioneRules = [true];
    this.telefonoUnoRules = [true];
    this.telefonoDueRules = [true];
    this.faxRules = [true];
    this.emailRules = [true];
    this.emailPecRules = [true];
    this.noteRules = [true];
    bus.$emit("closeCreateDialog");
  }

  async executeTest() {
    this.validazioneNominativo();
    this.validazioneMansione();
    this.validazioneTel();
    this.validazioneEmail();
    this.validazioneEmailPec();
    this.validazioneNote();
  }

  save() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var payload: ContattoAziendaInfo = {
          idContatto: 0,
          idAzienda: this.idAzienda,
          idIstituto: this.idIstituto,
          nominativo: this.nominativo,
          telefonoUno: this.telefonoUno,
          telefonoDue: this.telefonoDue,
          fax: this.fax,
          email: this.email,
          emailPec: this.emailPec,
          mansione: this.mansione,
          note: this.note
        };
        user
          .dispatchCreateContattoAzienda(this["$store"], payload)
          .then(() => {
            bus.$emit("successfullOperation", "Contatto creato con successo");
            this.close();
            bus.$emit("loadContattiAzienda");
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }
}
